module.exports = {"TXTCLI_Available":{"id":"TXTCLI_Available","defaultMessage":"Διαθέσιμα"},"TXTCLI_Expires":{"id":"TXTCLI_Expires","defaultMessage":"Λήγει"}}